import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbDownOutlined from '@material-ui/icons/ThumbDownOutlined';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbUpOutlined from '@material-ui/icons/ThumbUpOutlined';
import { FC } from 'react';

interface FeedbackButtonProps {
  isGood: boolean;
  isClicked: boolean;
  onClick?: () => void;
}

const FeedbackButton: FC<FeedbackButtonProps> = ({
  isGood,
  isClicked,
  onClick,
}) => {
  if (isGood && isClicked) {
    return <ThumbUp />;
  } else if (isGood && !isClicked) {
    return <ThumbUpOutlined onClick={onClick} />;
  } else if (!isGood && isClicked) {
    return <ThumbDown />;
  }
  // else
  return <ThumbDownOutlined onClick={onClick} />;
};

export default FeedbackButton;
